import React, { Component } from 'react'
import { Route } from 'react-router-dom';
import PrivateRoute from '../../util/PrivateRoute';
import { roles } from '../../util/Roles';
import Home from '../Home/Home';
import ArticulosAuxiliares from '../ArticulosAuxiliares/ArticulosAuxiliares';
import Usuarios from '../Usuarios/Usuarios';
// import CapturarInventario from '../CapturarInventario/CapturarInventario';
import HistoricoInventario from '../HistoricoInventario/HistoricoInventario';
import HistoricoPendienteSAP from '../HistoricoPendienteSAP/HistoricoPendienteSAP';
import FacturasVisualizador from '../Facturacion/FacturasVisualizador';
import CapturarInventarioPT from '../CapturarInventarioPT/CapturarInventarioPT';
import ListaInventarioPT from '../CapturarInventarioPT/ListaInventarios';
import ArticulosPT from '../ArticulosPT/ArticulosPT';
import Mermas from '../Reportes/Mermas/Mermas';
import DiferenciaInventario from '../Reportes/DiferenciaInventario/DiferenciaInventario';
import ReportViews from '../Reportes/DiferenciaInventario/ReportViews';
import { esBarras } from '../../util/generics';
import ListaInventariosBarras from '../CapturarInventarioBarras/ListaInventariosBarras';
import CapturarInventarioBarras from '../CapturarInventarioBarras/CapturarInventarioBarras';
import CapturarInventarioCiclico from '../CapturarCiclico/CapturarInventarioCiclico';
import ListaInventariosCiclicos from '../CapturarCiclico/ListaInventariosCiclico';
import ArticulosCiclicos from '../ArticulosCiclicos/ArticulosCiclicos';
import ReportViewsBarras from '../Reportes/DiferenciaInventario/ReportViewsBarras';

/**
 * Clase para ver las rutas
 */
class Routs extends Component {
    render() {
        return (
            <div>
                <Route exact path="/" component={Home} />
                <Route exact path="/inicio" component={Home} />
                <PrivateRoute path="/usuarios" component={Usuarios} roles={[roles.Admin]} />
                <PrivateRoute path="/articulos_auxiliares" component={ArticulosAuxiliares} roles={[roles.Admin, roles.Operador]} />
                <PrivateRoute path="/articulos_ciclicos" component={ArticulosCiclicos} roles={[roles.AdminCatalogos]} rolObligatorio={[roles.UsuarioBarra]} />
                <PrivateRoute path="/articulos_pte/:externo" component={ArticulosPT} roles={[roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]} />
                <PrivateRoute path="/articulos_pti/:externo" component={ArticulosPT} roles={[roles.Admin, roles.Operador]} />
                {/* <PrivateRoute path="/capturar_inventario" component={CapturarInventario} roles={[roles.Admin, roles.Operador]} /> */}
                <PrivateRoute path="/historico_inventario" component={HistoricoInventario} roles={[roles.Admin, roles.Operador]} />
                <PrivateRoute path="/historico_inventario_pt/:esExterno" component={HistoricoPendienteSAP} roles={[roles.Admin, roles.Operador]} />
                {/*<PrivateRoute path="/capturar_inventario_pt/:esExterno" component={CapturarInventarioPT} roles={[roles.Admin, roles.Operador]} />*/}
                {/*
                    Dependiendo del segmento al que pertenezca el usuario. Es el componente que se renderiza al entrar al link
                */}
                <PrivateRoute
                    path="/nuevoInventario/:idSitio/"
                    roles={[roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]}
                    render={props =>
                        esBarras()
                            ? <CapturarInventarioBarras {...props} />
                            : <CapturarInventarioPT {...props} />
                    }
                />
                <PrivateRoute
                    path="/editInventario/:idSitio/:idInvent"
                    roles={[roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]}
                    render={props =>
                        esBarras()
                            ? <CapturarInventarioBarras {...props} />
                            : <CapturarInventarioPT {...props} />
                    }
                />
                <PrivateRoute
                    path="/capturar_inventario_pt/:esExterno/:idSitio"
                    roles={[roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]}

                    render={props =>
                        esBarras()
                            ? <ListaInventariosBarras {...props} />
                            : <ListaInventarioPT {...props} />
                    }

                />
                <PrivateRoute
                    path="/capturar_inventario_ciclico/:idSitio?"
                    roles={[roles.Admin, roles.Operador, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]}
                    rolObligatorio={[roles.UsuarioBarra]}
                    component={ListaInventariosCiclicos}
                />
                <PrivateRoute
                    path="/nuevoCiclico/:idSitio/:idFrecuencia"
                    roles={[roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]}
                    component={CapturarInventarioCiclico}
                />
                <PrivateRoute
                    path="/editarCiclico/:idSitio/:idInventario/:idFrecuencia"
                    roles={[roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]}
                    component={CapturarInventarioCiclico}
                />
                <PrivateRoute path="/facturacion" component={FacturasVisualizador} roles={[roles.Operador, roles.Admin, roles.Asesor, roles.Auditor, roles.Barista]} />
                <PrivateRoute path="/mermas" component={Mermas} roles={[roles.Operador, roles.Admin, roles.Asesor, roles.Auditor, roles.Barista, roles.AdminCatalogos]} />
                <PrivateRoute
                    path="/diferencia_inventario"
                    roles={[roles.Admin, roles.Operador, roles.Auditor, roles.Asesor, roles.AdminCatalogos]}
                    render={props =>
                        esBarras()
                            ? <ReportViewsBarras {...props} />
                            : <ReportViews {...props} />
                    }
                />
            </div>
        )
    }
}

export default Routs;